import type { FC, ReactNode } from 'react'

import { useDictionary } from '@/lib/i18n'

// Decorative scrolling band. The list is doubled so the loop is seamless.
const TickerBand: FC = (): ReactNode => {
    const t = useDictionary()
    const items = [...t.ticker, ...t.ticker]

    return (
        <div aria-hidden='true' className='relative overflow-hidden border-y border-race bg-race py-4'>
            <div className='flex w-max motion-safe:animate-marquee'>
                {items.map((item, index) => (
                    <span
                        key={`${item}-${index}`}
                        className='flex items-center gap-8 whitespace-nowrap pr-8 font-heading text-2xl font-semibold uppercase tracking-[0.06em] text-white sm:text-3xl'
                    >
                        {item}
                        <span className='h-4 w-2 -skew-x-[18deg] bg-white/70' />
                    </span>
                ))}
            </div>
        </div>
    )
}

export default TickerBand
